<div class="rating-box">
    <div class="icon-box">
        <img *ngIf="annualGradeIcon" [src]="annualGradeIcon" alt="annualGrade" class="rating-icon">
        <span class="rating-text"><strong>{{annualGradeText ?? ""}}</strong></span>
    </div>    
    <span class="item-desc" *ngIf="description">{{description}}</span>
</div>